import {
  Box,
} from "@chakra-ui/react";

export const Footer = () => (
  <Box >
    FOOTER
  </Box>
);
